<template>
  <div>
    <b-row>
      <b-col>
        <h4 class="my-3">
          {{ $lang.partner_information }}
        </h4>
      </b-col>
    </b-row>
    <b-overlay :show="isLoading" rounded="sm">
      <div class="">
        <b-row class="m-1">
          <b-col
            cols="12"
            class="border-style px-0 pb-4 my-2"
            v-for="(item, index) in $v.items.$each.$iter"
            :key="index"
          >
            <b-row class="m-auto py-2">
              <b-col cols="12" sm="6" md="4" class="pad-5">
                <b-form-group
                  :label="$lang.name"
                  :label-cols="$config.form.labelCol"
                >
                  <b-form-input
                    type="text"
                    :autocomplete="$lang.name"
                    v-model="item.name.$model"
                    :state="item.name.$dirty ? !item.name.$error : null"
                  >
                  </b-form-input>

                  <b-form-invalid-feedback
                    v-if="!item.name.required"
                    id="name-feedback"
                  >
                    {{
                      $lang.error_required | replace($lang.name)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" class="pad-5">
                <b-form-group
                  :label="$lang.family"
                  :label-cols="$config.form.labelCol"
                >
                  <b-form-input
                    type="text"
                    :autocomplete="$lang.family"
                    v-model="item.family.$model"
                    :state="item.family.$dirty ? !item.family.$error : null"
                  >
                  </b-form-input>

                  <b-form-invalid-feedback
                    v-if="!item.family.required"
                    id="family-feedback"
                  >
                    {{
                      $lang.error_required | replace($lang.family)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" class="pad-5">
                <b-form-group
                  :label="$lang.national_code"
                  label-for="national_code"
                  :label-cols="$config.form.labelCol"
                >
                  <b-form-input
                    type="text"
                    autocomplete="off"
                    :state="
                      item.national_code.$dirty
                        ? !item.national_code.$error
                        : null
                    "
                    v-model="item.national_code.$model"
                  ></b-form-input>

                  <b-form-invalid-feedback id="father_name-feedback">
                    {{ $lang.error_required | replace($lang.national_code) }}
                  </b-form-invalid-feedback>
                  <div
                    class="invalid-feedback"
                    v-if="!item.national_code.numeric"
                  >
                    {{ $lang.error_numeric | replace($lang.national_code) }}
                  </div>
                  <div
                    class="invalid-feedback"
                    v-if="
                      item.national_code.numeric &&
                      !item.national_code.minLength |
                        !item.national_code.maxLength
                    "
                  >
                    {{ $lang.error_max | replace($lang.national_code, 10) }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="3" class="pad-5">
                <b-form-group
                  :label="$lang.birth_date"
                  label-for="birth_date"
                  :label-cols="$config.form.labelCol"
                >
                  <date-picker
                    v-model="item.birth_date.$model"
                    :state="
                      item.birth_date.$dirty ? !item.birth_date.$error : null
                    "
                    format="YYYY/MM/DD"
                    display-format="dddd jDD jMMMM jYYYY"
                    inputReq="true"
                    :clearable="true"
                    :class="
                      item.birth_date.$dirty
                        ? item.birth_date.$error
                          ? 'invalid-date'
                          : 'valid-date'
                        : null
                    "
                  >
                  </date-picker>
                  <b-form-invalid-feedback
                    :style="{
                      display: item.birth_date.$error ? 'block' : 'none',
                    }"
                    id="gender_id-feedback"
                  >
                    {{
                      $lang.error_required | replace($lang.birth_date)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="3" class="pad-5">
                <b-form-group
                  :label="$lang.date_marriage"
                  label-for="date_marriage"
                  :label-cols="$config.form.labelCol"
                >
                  <date-picker
                    v-model="item.date_marriage.$model"
                    :state="
                      item.date_marriage.$dirty
                        ? !item.date_marriage.$error
                        : null
                    "
                    format="YYYY/MM/DD"
                    display-format="dddd jDD jMMMM jYYYY"
                    inputReq="true"
                    :clearable="true"
                    :class="
                      item.date_marriage.$dirty
                        ? item.date_marriage.$error
                          ? 'invalid-date'
                          : 'valid-date'
                        : null
                    "
                  >
                  </date-picker>
                  <b-form-invalid-feedback
                    :style="{
                      display: item.date_marriage.$error ? 'block' : 'none',
                    }"
                    id="gender_id-feedback"
                  >
                    {{
                      $lang.error_required | replace($lang.date_marriage)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="3" class="pad-5">
                <b-form-group
                  :label="$lang.date_separation_death"
                  label-for="date_separation_death"
                  :label-cols="$config.form.labelCol"
                >
                  <date-picker
                    v-model="item.date_separation_death.$model"
                    :state="
                      item.date_separation_death.$dirty
                        ? !item.date_separation_death.$error
                        : null
                    "
                    format="YYYY/MM/DD"
                    display-format="dddd jDD jMMMM jYYYY"
                    inputReq="true"
                    :clearable="true"
                    :class="
                      item.date_separation_death.$dirty
                        ? item.date_separation_death.$error
                          ? 'invalid-date'
                          : 'valid-date'
                        : null
                    "
                  >
                  </date-picker>
                  <b-form-invalid-feedback
                    :style="{
                      display: item.date_separation_death.$error
                        ? 'block'
                        : 'none',
                    }"
                    id="gender_id-feedback"
                  >
                    {{
                      $lang.error_required
                        | replace($lang.date_separation_death)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="3" class="pad-5">
                <b-form-group
                  :label="$lang.date_death"
                  label-for="date_death"
                  :label-cols="$config.form.labelCol"
                >
                  <date-picker
                    v-model="item.date_death.$model"
                    :state="
                      item.date_death.$dirty ? !item.date_death.$error : null
                    "
                    format="YYYY/MM/DD"
                    display-format="dddd jDD jMMMM jYYYY"
                    inputReq="true"
                    :clearable="true"
                    :class="
                      item.date_death.$dirty
                        ? item.date_death.$error
                          ? 'invalid-date'
                          : 'valid-date'
                        : null
                    "
                  >
                  </date-picker>
                  <b-form-invalid-feedback
                    :style="{
                      display: item.date_death.$error ? 'block' : 'none',
                    }"
                    id="gender_id-feedback"
                  >
                    {{
                      $lang.error_required | replace($lang.date_death)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" class="pad-5">
                <b-form-group
                  :label="$lang.mobile"
                  label-for="mobile"
                  :label-cols="12"
                >
                  <b-form-input
                    type="text"
                    :autocomplete="$lang.mobile"
                    placeholder="مثال:09121112233 "
                    :state="item.mobile.$dirty ? !item.mobile.$error : null"
                    v-model="item.mobile.$model"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="mobile-feedback"
                    >{{ $lang.error_required | replace($lang.mobile) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" class="pad-5">
                <b-form-group
                  :label="$lang.city_address_home"
                  :label-cols="$config.form.labelCol"
                >
                  <selectAsync
                    :options="location_options"
                    v-model="item.location_selected.$model"
                    label="caption"
                    :asyncFind="getkind"
                    :isValid="
                      item.location_selected.$dirty
                        ? !item.location_selected.$error
                        : null
                    "
                    :loading="locationLoading"
                    :placeholder="$lang.search_city"
                  />
                  <b-form-invalid-feedback
                    :style="{
                      display: item.location_selected.$error ? 'block' : 'none',
                    }"
                    id="gender_id-feedback"
                  >
                    {{
                      $lang.error_required | replace($lang.city_address_home)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" class="pad-5">
                <b-form-group
                  :label="$lang.regional_municipality"
                  label-for="regional_municipality"
                  :label-cols="$config.form.labelCol"
                >
                  <b-form-input
                    type="text"
                    :autocomplete="$lang.regional_municipality"
                    v-model="item.regional_municipality.$model"
                    :state="
                      item.regional_municipality.$dirty
                        ? !item.regional_municipality.$error
                        : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="description-feedback">
                    {{
                      $lang.error_required
                        | replace($lang.regional_municipality)
                    }}
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback
                    v-if="item.regional_municipality.$error"
                    id="name-feedback"
                  >
                    {{
                      $lang.error_Value
                        .replace("{0}", $lang.Personal_biography)
                        .replace("{1}", "1")
                        .replace("{2}", "25")
                    }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col cols="12" class="pad-5">
                <b-form-group
                  :label="$lang.description"
                  label-for="description"
                  :label-cols="12"
                >
                  <b-form-textarea
                    id="description"
                    :state="
                      item.description.$dirty ? !item.description.$error : null
                    "
                    v-model="item.description.$model"
                    type="text"
                    :autocomplete="$lang.description"
                    :rows="$config.form.textareaRows"
                  ></b-form-textarea>
                  <b-form-invalid-feedback id="description-feedback">
                    {{ $lang.error_required | replace($lang.description) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-button
              variant="danger"
              class="btn-my-desgin"
              @click="removeColumn(item, index)"
            >
              {{ $lang.delete_all_row }}
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-overlay>
    <b-row>
      <b-col cols="12" class="mt-1">
        <b-button class="float-right" variant="success" @click="addColumn">
          {{ $lang.Add_new_item }}
        </b-button>
      </b-col>
    </b-row>
    <confirm
      :title="modalTitle"
      :description="message"
      v-model="confirmModal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @ok="okConfim"
      @cancel="cancelConfim"
    ></confirm>
  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  requiredIf,
  numeric,
} from "vuelidate/lib/validators";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import confirm from "@/components/base/confirm";

export default {
  validations: {
    items: {
      $each: {
        name: {
          requiredIf: requiredIf(function (value) {
            this.items.map((x) => {
              if (x.name) {
                this.itemsRequired = true;
                return true;
              } else {
                this.itemsRequired = false;
                return false;
              }
            });
          }),
        },
        family: {
          requiredIf: requiredIf(function (value) {
            if (this.itemsRequired) {
              return true;
            } else {
              return false;
            }
          }),
        },
        mobile: {
          requiredIf: requiredIf(function (value) {
            if (this.itemsRequired) {
              return true;
            } else {
              return false;
            }
          }),
          numeric,
          minLength: minLength(11),
          maxLength: maxLength(11),
        },
        national_code: {
          requiredIf: requiredIf(function (value) {
            if (this.itemsRequired) {
              return true;
            } else {
              return false;
            }
          }),
          numeric,
          minLength: minLength(10),
          maxLength: maxLength(10),
        },
        regional_municipality: {},
        location_selected: {
          requiredIf: requiredIf(function (value) {
            if (this.itemsRequired) {
              return true;
            } else {
              return false;
            }
          }),
        },
        birth_date: {
          requiredIf: requiredIf(function (value) {
            if (this.itemsRequired) {
              return true;
            } else {
              return false;
            }
          }),
        },
        date_separation_death: {},
        date_death: {},
        date_marriage: {},
        description: {},
      },
    },
  },
  props: {
    code: {
      type: String,
    },
  },
  components: {
    datePicker: VuePersianDatetimePicker,
    confirm,
  },
  data() {
    return {
      items: [
        {
          name: null,
          family: null,
          mobile: null,
          national_code: null,
          regional_municipality: null,
          location_selected: null,
          birth_date: null,
          date_separation_death: null,
          date_death: null,
          date_marriage: null,
          description: null,
        },
      ],

      itemsRequired: false,
      confirmModal: false, // بازکردن مدال کانفرم
      modalTitle: "", // عنوان مدال
      message: "", // نمایش متن حذف فایل
      isLoading: false,
      location_options: [],
      locationLoading: false,
      removingItem: {},
      confirmPersonModal: false,
    };
  },
  inject: ["personRelationRepository"],
  methods: {
    async getkind(query) {
      if (!query || query.length < 2) {
        this.location_options = [];
        return;
      }
      try {
        let url =
          this.$config.api_url +
          this.$config.resources.location +
          `?city=${query}`;
        const response = await this.$httpService.get(url);
        let locations = response.data.data;
        this.location_options = locations;
      } catch (error) {
        this.$generateError(error);
        this.location_options = [];
      }
    },
    addColumn() {
      this.items.push({
        name: null,
        family: null,
        mobile: null,
        national_code: null,
        regional_municipality: null,
        location_selected: null,
        birth_date: null,
        date_separation_death: null,
        date_death: null,
        date_marriage: null,
        description: null,
      });
    },
    removeColumn(item, index) {
      if (item.$model.id) {
        this.removingItem = {
          id: item.$model.id,
          index: index,
        };
        this.message = this.$lang.are_you_sure_to_remove_item.replace(
          "{item}",
          this.$lang.data
        );
        this.modalTitle = this.$lang.remove_item;
        this.confirmModal = true;
      } else {
        this.items.splice(this.removingItem && this.removingItem.index, 1);
      }
    },
    clearModalConfirm() {
      this.modalTitle = "";
      this.message = "";
      this.removingItem = {};
    },
    async okConfim() {
      try {
        this.isLoading = true;
        const response = await this.personRelationRepository.delete(
          this.code,
          this.removingItem && this.removingItem.id
        );
        this.items.splice(this.removingItem && this.removingItem.index, 1);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
        this.clearModalConfirm();
      }
    },
    cancelConfim() {
      this.confirmModal = false;
      this.clearModalConfirm();
    },

    async save() {
      this.$v.$touch();

      if (this.$v.$anyError) {
        return;
      }

      let resItems = [];
      if (this.items.filter((x) => x.family).length > 0) {
        this.items.map((x) => {
          let payload = {
            name: x.name,
            family: x.family,
            mobile: x.mobile,
            email: x.email,
            meta_data: {
              birth_date: x.birth_date,
              date_separation_death: x.date_separation_death,
              date_marriage: x.date_marriage,
              date_death: x.date_death,
            },
            gender_id: x.gender_selected && x.gender_selected.value,
            national_code: x.national_code,
            relation_type_id: this.$config.relation_type.partnerform,
            description: x.description,
            zone_number: x.regional_municipality,
            location_id: x.location_selected && x.location_selected.id,
          };
          let id = x.code ? x.code : null;
          let PersonRelation = this.putPersonRelation(payload, id);
          resItems.push(PersonRelation);
        });
      }
      return resItems;
    },
  },
  created() {
    this.getPersonRelation(
      this.code,
      this.$config.relation_type.partnerform
    ).then(() => {
      if (this.relations.length > 0) this.items = this.relations;
    });
  },
};
</script>
